export default __webpack_public_path__ + "static/media/About4.40d6727f.png";